module.exports = __webpack_public_path__ + "img/probability_up_tw.25c46e5f.png";